/* !
 * product.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	const prodBrandSlider = () => {
		const swiper = new Swiper('.top-prodBrand-slider.swiper', {
			loop: true,
			loopAdditionalSlides: 1,
			effect: 'slide',
			speed: 500,
			autoplay: false,
			slidesPerView: 1,
			spaceBetween: 16,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1025: {
					slidesPerView: 2,
					spaceBetween: 40,
					pagination: false,
				}
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const productFUNCTIONS = () => {
		prodBrandSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { productFUNCTIONS(); }) : productFUNCTIONS();

})(window.FUNCTIONS);
